 jQuery(document).ready(function($) {
  if($('.custom-mounthood').length || $('.custom-hood-river').length ){
    $('.foodtruck-body').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '.prev_slide',
      nextArrow: '.next_slide',
      cssEase: 'linear',    
    });
    
    $('.blog__posts').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      prevArrow: '.prev_slide1',
      nextArrow: '.next_slide1',
      responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1
          }
        }              
      ]
    })

    $('.multicolumn-slider .multicolumn-list').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: '.prev_slide2',
        nextArrow: '.next_slide2',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
              breakpoint: 749,
              settings: {
                slidesToShow: 1
              }
          }
        ]
    });  
  }
  
    $('.custom-mega-menu').each(function(){
        var obj = $(this).data('meganav');
        if($('.menu-drawer__menu li[data-handle="'+obj+'"]').length){
            $('.menu-drawer__menu li[data-handle="'+obj+'"] a').removeClass('hideicon')
        }
    })

      
    $('header-drawer svg.icon.icon-close').click(function(){
        $('.menu-drawer__inner-container').removeClass('hidden');
        $('.custom-mega-menu').removeClass('open')
    })
    if($('.template-index').length || $('.template-collection').length ){
      $('.blog__posts').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows : false,
        loop: false,
        responsive: [
          {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1
            }
          }              
        ]
      })
    }
      
    if($('.brands').length){
      $('.brands').removeClass('hidden')
      $('.brands').slick({
          slidesToShow: 8,
          slidesToScroll: 1,
          autoplay: false,
          prevArrow: '<svg width="8" class="left-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1.5 6L6.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
          nextArrow: '<svg width="8" class="right-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="#527769" stroke-width="1.5"/></svg',
          responsive: [
              {
                  breakpoint: 749,
                  settings: {
                    slidesToShow: 3
                  }
              }
          ]
      })
    }

    if($('.slideitems').length){
      $('.slideitems').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: true,
        speed: 400,
        prevArrow: '<svg width="8" class="left-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1.5 6L6.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
        nextArrow: '<svg width="8" class="right-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="#527769" stroke-width="1.5"/></svg>'
      });
    }

    $('modal-opener').click(function(){
      setTimeout(function(){
       (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/yTQjyk2MNEyvSlc1eIOdwTb3598HYwuAJ0DEKLl4/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();
      },2000)
    })


   $('.menu-drawer__navigation li').click(function(){
    
     if($('[data-meganav="'+$(this).data('handle')+'"]').length){
        $(this).parents('.menu-drawer__inner-container').addClass('hidden');
        $('[data-meganav="'+$(this).data('handle')+'"]').toggleClass('open').siblings().removeClass('open')
        $('[data-meganav="'+$(this).data('handle')+'"]').find('.custom-mega-menu__content').removeClass('open')
        $('[data-meganav="'+$(this).data('handle')+'"]').find('.custom-list-unstyled').removeClass('open')
     }
    })

    $('.optionfor li').click(function () {
      $('.menu-drawer__inner-container').removeClass('hidden')
      $(this).parents('.custom-mega-menu').removeClass('open');      
    })
  
     $('.header__inline-menu li a').click(function() {
          $(this).closest('li').toggleClass('open').siblings().removeClass('open')
          $('[data-meganav="'+$(this).closest('li').data('handle')+'"]').toggleClass('open').siblings().removeClass('open')
          $('[data-meganav="'+$(this).closest('li').data('handle')+'"]').find('.custom-mega-menu__content').removeClass('open')
          $('[data-meganav="'+$(this).closest('li').data('handle')+'"]').find('.custom-list-unstyled').removeClass('open')
          if($('.custom-mega-menu.open').length){
              $('body').addClass('overflow')
          }else{
              $('body').removeClass('overflow')
          }
       }) 
      
      // $('.header__inline-menu li').on( "mouseleave", function() {
      //     $(this).removeClass('open');
      //     $('[data-meganav="'+$(this).data('handle')+'"]').removeClass('open')
      //     $('body').removeClass('overflow')
      // })
      
      $('.inner-megamenu').on( "mouseenter", function() {
          $(this).parents('.custom-mega-menu').addClass('open')
          var handl = $(this).parents('.custom-mega-menu').attr('meganav');
          $('.header__inline-menu li[data-handle="'+handl+'"]').addClass('open')
      })

      // ios menu issue
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      });      

      if ( $(window).width() <= 1279 ) {  
        $('.custom-header__menu-item').on( "click", function() {
          $(this).toggleClass('active')
          $(this).parents('.custom-mega-menu , li').toggleClass('mobmenuactive')
          $(this).parent().find('.custom-mega-menu__content').toggleClass('open')
          $(this).parents('li').siblings().find('.custom-mega-menu__content').toggleClass('open')
          $(this).parents('li').siblings().find('.custom-header__menu-item').toggleClass('active')
        })
        $('.custom-mega-menu__list .sec_menu a').on( "click", function() {
          $(this).parent().toggleClass('active').siblings().removeClass('active')
          $(this).parent().find('.custom-list-unstyled').toggleClass('open')
          $(this).parent().siblings().find('.custom-list-unstyled').removeClass('open')
        })         
      }else{
        $('.custom-header__menu-item').on( "mouseenter", function() {
          $(this).addClass('active')
          $(this).parents('.custom-mega-menu , li').addClass('mobmenuactive')
          $(this).parent().find('.custom-mega-menu__content').addClass('open')
          $(this).parents('li').siblings().find('.custom-mega-menu__content').removeClass('open')
          $(this).parents('li').siblings().find('.custom-header__menu-item').removeClass('active')
        })
        $('.custom-mega-menu__list .sec_menu a').on( "mouseenter", function() {
          $(this).parent().addClass('active').siblings().removeClass('active')
          $(this).parent().find('.custom-list-unstyled').addClass('open')
          $(this).parent().siblings().find('.custom-list-unstyled').removeClass('open')
        })      
        $(document).on('click', function(event) {
          if (!$(event.target).closest('.header__inline-menu, .custom-mega-menu .page-width').length) {
            $('.header__inline-menu li.open').removeClass('open');
            $('.custom-mega-menu.open').removeClass('open');
            $('body').removeClass('overflow');
          }
        });            
      }

    // $('.custom-mega-menu .overlay').on( "mouseenter", function() {
    //     $('.custom-mega-menu').removeClass('open')
    //     $('body').removeClass('overflow')
    //     $('.header__inline-menu li').removeClass('open')
    // })

     if (window.matchMedia('(max-width: 1023px)').matches) {
       if($('.slider-mobile-gutter .collection-list').length){
            $('.slider-mobile-gutter .collection-list').slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              autoplay: false,
              cssEase: 'linear',
              arrows: false,
              responsive: [
                {
                    breakpoint: 749,
                    settings: {
                      slidesToShow: 2.1
                    }
                }
            ]
            })
       }
      }

      // Toggle the .all-locations when the .locations element is clicked
      $('body').on('click', '.locations', function(event){
        event.stopPropagation();
        $('.all-locations').slideToggle();
      });
    
      $(document).on('click', function(event) {
        if (!$(event.target).closest('.locations, .all-locations').length) {
          $('.all-locations').slideUp();
        }
      });
      

  if($('.block__video-slider').length){
    $('.block__video-slider').slick({
        slidesToShow: 4.5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        pauseOnHover: false,
        arrows: false,
        responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3
              }
            },
            {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 3
                }
            },
            {
                breakpoint: 749,
                settings: {
                  slidesToShow: 1.2
                }
            }
        ]
    });
  }

  if($('.slideshow-body').length){
    $('.slideshow-body').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      cssEase: 'linear',
      arrows: true,
      dots: true,
      prevArrow: '<svg width="8" class="left-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1.5 6L6.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
      nextArrow: '<svg width="8" class="right-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="#527769" stroke-width="1.5"/></svg>'
    });
    // Ensure videos auto-play when switching slides
    $('.slideshow-body').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var currentVideo = $(slick.$slides[currentSlide]).find('video')[0];
      if (currentVideo) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }
    });  
    // Play the video in the next slide after the slide transition
    $('.slideshow-body').on('afterChange', function(event, slick, currentSlide) {
      var nextVideo = $(slick.$slides[currentSlide]).find('video')[0];
      if (nextVideo) {
        nextVideo.play();
      }
    });
    // Listen for video end in each slide
    $('.slideshow-body').find('video').each(function() {
      var video = this;
      $(video).on('ended', function() {
        $('.slideshow-body').slick('slickNext');
      });
    });
  }

  
    $(document).on("click",".block__collection-tabs-title",function(){
        var data_id = $(this).attr('data-id');
        $(this).parents('.block__collection-tabs-contents').find(".block__collection-tabs-title").removeClass("active");
        $(this).parents('.block__collection-tabs-contents').find(".block__collection-tabs-product-list").addClass("hidden");
        $(this).addClass("active");
        $(this).parents('.block__collection-tabs-contents').find(".block__collection-tabs-product-list#"+data_id).removeClass("hidden");
    });

    if($('.new-arrivals .featured_product_grid_slider').length){
      $('.new-arrivals .featured_product_grid_slider').each(function(){
          var $this = $(this);
          $this.slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              prevArrow: $this.parents(".collection").find(".block__collection-slider-arrow-left"),
              nextArrow: $this.parents(".collection").find(".block__collection-slider-arrow-right"),
              responsive: [
                {
                  breakpoint: 1500,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                    breakpoint: 1400,
                    settings: {
                      slidesToShow: 2
                    }
                },
                {
                    breakpoint: 483,
                    settings: {
                      slidesToShow: 1
                    }
                }
            ]
          });
      });
    }

   if($('.block__member-collection-member-footer-slider').length){
      $('.block__member-collection-member-footer-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          infinite: true,
          arrows: false,
          autoplay: true,
          speed: 400,
      });
   }
  
   if($('.custom-cards ul.collection-list.contains-card.slick-initialized').length == 0){
    $('.custom-cards ul.collection-list.contains-card').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<svg width="8" class="left-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 1L1.5 6L6.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
      nextArrow: '<svg width="8" class="right-arrow" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1L6.5 6L1.5 11" stroke="#527769" stroke-width="1.5"/></svg>',
      speed: 600,
      cssEase: 'ease',
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2.5
          }
        }
      ]
    });
  }
  

  $('[for="SortBy-mobile"]').click(function(){
      $('.mobile-facets__disclosure').attr('open','open')
      $('.mobile-facets__disclosure').addClass('menu-opening');
      $('.mobile-facets__main').addClass('hidden');
      $('.select-sort').removeClass('hidden')
  })
  $('.mobile-facets__open').click(function(){
      $('.mobile-facets__main').removeClass('hidden');
      $('.select-sort').addClass('hidden')
  })

  
    if (window.matchMedia('(max-width: 749px)').matches) {
       $('.block__member-collection-section .block__member-collection-list').slick({
          slidesToShow: 1.2,
          slidesToScroll: 1,
          autoplay: false,
          cssEase: 'linear',
          arrows: false
        })

      $('.brands').removeClass('mobslide')
      $('.footermenu').click(function () {
          $(this).parents('.footer-block-link_list').toggleClass('open');
          $(this).parents('.footer-block-link_list').find('.footer-block__details-content').slideToggle();
      })

      const menu = document.querySelector(".select-menu");
      if(menu){
        const [selectBtn, sBtnText] = [menu.querySelector(".select-btn"), menu.querySelector(".sBtn-text")];
        
        selectBtn.onclick = () => menu.classList.toggle("active");
        
        menu.querySelectorAll(".option").forEach(option => {
          option.onclick = () => {
            sBtnText.innerText = option.querySelector(".option-text").innerText;
            menu.classList.remove("active");
          };
        });
      }
    
    }

});

// Set loader in the membership price on the PDP page
if(document.querySelector('.memeber-loader') != null) {
  document.querySelector('.memeber-loader').querySelector('.loading__spinner').classList.remove('hidden');
  document.querySelector('.memeber-loader').querySelector('.money').classList.add('hidden');
  setTimeout(function(){
    document.querySelector('.memeber-loader').querySelector('.loading__spinner').classList.add('hidden');
    document.querySelector('.memeber-loader').querySelector('.money').classList.remove('hidden');
  },2000);
}